import { Controller } from "@hotwired/stimulus";


export default class extends Controller {
    static targets = ["input", "dropdown", "radio"]
    static values = {
        "name": String
    }

    initialize() {
        this.handleChange();
        const clickEventTypes = ["mouse", "touch"];

        this.inputTarget.addEventListener("focus", this.showDropdown.bind(this));
        this.radioTargets.forEach(element => {
            element.addEventListener("focusin", this.showDropdown.bind(this));
            element.addEventListener("change", this.handleChange.bind(this));
        });
        this.dropdownTarget.addEventListener("click", (e) => {
            if (clickEventTypes.includes(e.pointerType)) {
                this.hideDropdown();
            }
        })
        this.element.addEventListener("keydown", (e) => {
            if (e.key == "Tab") {
                if (document.activeElement.type == "radio") {
                    if (this.isLastRadioButton(document.activeElement)) {
                        this.hideDropdown();
                    } else {
                        e.preventDefault();
                        this.focusNextRadioButton(document.activeElement);
                    }
                } else if (document.activeElement == this.inputTarget && e.shiftKey) {
                    this.hideDropdown();
                }
            }
        })
        document.addEventListener("click", (e) => {
            if (clickEventTypes.includes(e.pointerType) && !this.element.contains(e.target)) {
                this.hideDropdown();
            }
        })
    }

    showDropdown() {
        this.dropdownTarget.classList.remove("opacity-0");
        this.dropdownTarget.classList.remove("hidden");
    }

    hideDropdown() {
        this.dropdownTarget.classList.add("opacity-0");
        this.dropdownTarget.classList.add("hidden");
    }

    handleChange() {
        const checkedRole = this.element.querySelector(`input[name="${this.nameValue}"]:checked`);
        if (!checkedRole) return;
        this.inputTarget.value = checkedRole.parentElement.textContent.trim();
        this.radioTargets.forEach(element => {
            element.parentElement.classList.remove("bg-light");
        });
        checkedRole.parentElement.classList.add("bg-light");
    }

    isLastRadioButton(element) {
        return element === this.radioTargets[this.radioTargets.length - 1];
    }

    focusNextRadioButton(currentRadioButton) {
        const currentIndex = this.radioTargets.indexOf(currentRadioButton);
        if (currentIndex < this.radioTargets.length - 1) {
            const nextRadioButton = this.radioTargets[currentIndex + 1];
            nextRadioButton.focus();
        }
    }
}
